import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-eula-dialog',
  templateUrl: './eula-dialog.component.html',
  styleUrls: ['./eula-dialog.component.scss']
})
export class EulaDialogComponent implements OnInit {

  pdfUrl: SafeResourceUrl | null = null;
  showHtmlContent: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<EulaDialogComponent>,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    if (this.data?.pdfUrl) {
      const cleanUrl = `${this.data.pdfUrl}#toolbar=0&navpanes=0&scrollbar=0`;
      this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(cleanUrl);
    }
  }
  

  closeDialog() {
    this.dialogRef.close();
  }
}

